<main>
    <div class="container">

        <div class="row mb-4 mb-lg-5">

            <div id="accordionMenu" class=" col-12 col-lg-12 mt-4 mt-lg-0">

                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#itemMenu8">
                            <h5 class="m-0">Alterar Senha</h5>
                        </button>
                    </div>
                    <div id="itemMenu8" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-alt-senha></app-alt-senha>    
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#itemMenu9">
                            <h5 class="m-0">Assinatura Eletrônica</h5>
                        </button>
                    </div>
                    <div id="itemMenu9" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-assinatura-eletronica></app-assinatura-eletronica>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#itemMenu3">
                            <h5 class="m-0">Dados de Contato</h5>
                        </button>
                    </div>
                    <div id="itemMenu3" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-alt-contato></app-alt-contato>
                        </div>
                    </div>
                </div>


                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed btn-dados-pessoais" data-toggle="collapse" data-target="#itemMenu1" (click)="dadosPessoais.buscaDadosPessoais()">
                            <h5 class="m-0">Dados Pessoais</h5>
                        </button>
                    </div>
                    <div id="itemMenu1" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-dados-pessoais #dadosPessoais></app-dados-pessoais>
                        </div>
                    </div>
                </div>
                
                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed btn-endereco" data-toggle="collapse" data-target="#itemMenu2">
                            <h5 class="m-0">Endereço</h5>
                        </button>
                    </div>
                    <div id="itemMenu2" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-alt-endereco></app-alt-endereco>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0" [hidden]="!itemRepresLegal">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#itemMenu4">
                            <h5 class="m-0">Titular Responsável</h5>
                        </button>
                    </div>
                    <div id="itemMenu4" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-alt-repres-legal (exibirItem)="itemRepresLegal = $event"></app-alt-repres-legal>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed btn-beneficiarios" data-toggle="collapse" data-target="#itemMenu5" (click)="beneficiario.listar()">
                            <h5 class="m-0">Meus Beneficiários</h5>
                        </button>
                    </div>
                    <div id="itemMenu5" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-beneficiario #beneficiario></app-beneficiario>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0" [hidden]="!itemDadosAssociado">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#itemMenu6">
                            <h5 class="m-0">Vínculo Participante Fusan</h5>
                        </button>
                    </div>
                    <div id="itemMenu6" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-dados-associado (exibirItem)="itemDadosAssociado = $event"></app-dados-associado>
                        </div>
                    </div>
                </div>

                <div class="card mb-3 border-0">
                    <div class="card-header border-0 bg-transparent pl-0 pr-4 pl-lg-3 pr-lg-4 py-1 py-lg-3">
                        <button class="btn btn-link collapsed btn-termos" data-toggle="collapse" data-target="#itemMenu7">
                            <h5 class="m-0">Termos</h5>
                        </button>
                    </div>
                    <div id="itemMenu7" class="collapse" data-parent="#accordionMenu">
                        <div class="card-body pt-2">
                            <app-termos></app-termos>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</main>    